let incense = [
    {
        id:0,
        title:"블루밍 캔들 씨드",
        imgUrl:"/img/incense.jpg",
        content:"플래그십 스토어 한정 판매",
        price:76000
    },

    {
        id:1,
        title:"블루밍 캔들 버드",
        imgUrl:"/img/incense2.jpg",
        content:"플래그십 스토어 한정 판매",
        price:219000
    },

    {
        id:2,
        title:"블루밍 캔들 스몰트리",
        imgUrl:"/img/incense3.jpg",
        content:"플래그십 스토어 한정 판매",
        price:179000
    },

    {
        id:3,
        title:"블루밍 캔들 빅트리",
        imgUrl:"/img/incense4.jpg",
        content:"플래그십 스토어 한정 판매",
        price:225000
    }
]

export default incense; 